import { useQuery } from "@tanstack/react-query";
import { getAuthUsers } from "@/api/v1-jwt/tenancy/tenancy";
import { useAuth } from "@/providers/auth";

export const useAuthUsers = ({
  queryKey,
  queryFn,
  enabled,
  ...config
} = {}) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!id && enabled !== false;
  return useQuery({
    queryKey: ["tenancy", "auth_users"],
    queryFn: async () => getAuthUsers({ clientId: id }),
    staleTime: 5 * 60 * 1000,
    enabled: isEnabled,
    ...config,
  });
};
